import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const RecProductList = styled.div`
  padding: 12px 0;

  &.bg-type {
    padding: 36px 0;
    background: #f6f6f6;
    border-bottom: 1px solid #fff;

    .section-title {
      padding-bottom: 8px;
    }

    .tag-ad {
      width: 31px;
      height: 21px;
      padding: 0;
      font-size: 13px;
      border: 1px solid #e2e2e2;
      background-color: transparent;
    }

    .product-item .area-img .img:after {
      display: none;
    }
  }

  .box .menu-bar-category {
    background: transparent;

    .swiper-slide {
      .active .area-click {
        background: #000;
        color: #fff;
      }

      .area-click {
        background: #e9e9e9;
        color: #9d9d9d;
      }
    }
  }

  .emblem-area svg {
    width: 32px;
    top: 8px;
    right: 7px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('12 0')};

    &.bg-type {
      padding: ${mixin.pxToVw('36 0')};

      .section-title {
        padding-bottom: ${mixin.pxToVw('8')};
      }

      .tag-ad {
        width: ${mixin.pxToVw('31')};
        height: ${mixin.pxToVw('21')};
        font-size: ${mixin.pxToVw('13')};
      }
    }
  }
`;
